module.exports =
{

  _init: function ()
  {

    APPLICATION._APPLICATION.processLinks("#orders", "WifiGuarantee", "orders")

    $("#guarantee_id").val("")

  }

}